module.exports = __webpack_public_path__ + "img/Fiche responsable vie associative.814d40c9.jpg";